import { EventEmitter, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { isDefined } from '../utils/index';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingService {
    private toggleLoading = new EventEmitter<boolean>();

    constructor() {}

    startLoading() {
        this.toggleLoading.emit(true);
        return () => this.finishLoading();
    }

    finishLoading() {
        this.toggleLoading.emit(false);
    }

    trackPromise<T>(promise: Promise<T>, delay?: number): Promise<T> {
        if (isDefined(delay)) {
            setTimeout(() => this.startLoading(), delay);
        } else {
            this.startLoading();
        }
        promise.finally(() => {
            if (isDefined(delay)) {
                setTimeout(() => this.finishLoading(), delay);
            } else {
                this.finishLoading();
            }
        });
        return promise;
    }

    onToggleLoading(callback: (loading: boolean) => void): Subscription {
        return this.toggleLoading.subscribe(callback);
    }

    subscribeOnLoadingSubject(loading$: Subject<boolean>) {
        loading$.subscribe((v) => {
            if (v) this.startLoading();
            else this.finishLoading();
        });
    }
}
